import Image from "@pathwright/ui/src/components/image/Image"
import styled from "styled-components"

export const StyledEditControls = styled.div`
  display: flex;
  padding: 5px;
  position: absolute;
  left: 0;
  transition: top 0.5s, opacity 0.5s;
  width: 100%;
  overflow: auto;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.5);
  z-index: 5;

  html.no-touch & {
    opacity: 0;
    top: -60px;
  }
`
export const StyledThumbnail = styled.div`
  margin-right: 5px;
  position: relative;
  height: 80px;
  line-height: 1.15;

  @media (max-width: 768px) {
    height: 40px;
  }

  width: 80px;
  background-position: 50%;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  &:hover > div {
    display: block;
  }

  .Pathicon {
    height: 12px;
    width: 12px;
    line-height: 12px;
    min-height: unset;
    min-width: unset;
  }
`

export const IconContainer = styled.div`
  display: block;
  position: absolute;
  width: 18px;
  height: 18px;
  padding: 2px;
  top: 2px;
  left: 2px;
  cursor: pointer;

  font-size: 14px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 50%;
`

export const StyledCarousel = styled.div`
  // background-color: #2a2e33;
  text-align: center;
  font-size: 16px;
  overflow: hidden;
  position: relative;
  .slick-arrow {
    background-color: #efefef;
    width: 40px !important;
    height: 40px !important;
    line-height: 30px;
    padding: 0px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.05);
  }
  .slick-arrow:hover {
    background-color: #efefef;
  }
  .slick-prev {
    left: 7px;
  }
  .slick-next {
    right: 7px;
  }
  .slick-prev:before {
    content: "\\E640" !important;
    font-family: pathicons;
    color: rgb(136, 134, 135);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .slick-next:before {
    content: "\\E63E" !important;
    font-family: pathicons;
    color: rgb(136, 134, 135);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .slick-prev .Pathicon {
    width: 70px;
    height: 70px;
    content: "";
    font-size: 65px;
    top: -15px;
    left: -15px;
    position: absolute;
  }
  .slick-next .Pathicon {
    width: 70px;
    height: 70px;
    content: "";
    font-size: 65px;
    top: -15px;
    right: -15px;
    position: absolute;
  }
  img {
    max-width: 100%;
  }

  &:hover > .edit-controls {
    top: 0;
    opacity: 1;
  }
`

export const StyledCarouselImage = styled(Image)`
  width: 100%;
  max-width: 100%;
`

export const GridContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const GridImage = styled.div`
  width: ${(p) => 100 / p.columns}%;
  margin-right: 10px;
  margin-left: 10px;
  &:first-child {
    margin-left: 0px;
  }
  &:last-child {
    margin-right: 0px;
  }
  img {
    display: block;
    width: 100%;
  }
`
